import firebase from "../FirebaseConfig";

export const imageUpload = async (file: any, name: string): Promise<string> => {
	const storage = firebase.storage();
	const storageRef = storage.ref(
		`${name}`
	);
	const snapShot = await storageRef.put(file);
	return await snapShot.ref.getDownloadURL();
}